export enum PlanPlatform {
  ANDROID = "android",
  IOS = "ios",
}
